import { App } from 'vue';

import { provideRpcClient } from './rpc-client';

export function setupProvides(app: App) {
  provideRpcClient(app);
}
